export default "__VITE_ASSET__D9J318ca__"